import React, { useState } from 'react';
import { SectionTitle } from './SectionTitle';
import { MediaSlot } from './MediaSlot';
import { CheckoutCta } from './CheckoutCta';
import { printedPhotos } from '../../data/media';

/** Kb. 4,5 mp képenként. */
const SECONDS_PER_PHOTO = 4.5;
export function PrintedGallery() {
  const [paused, setPaused] = useState(false);
  // A sor kétszer ismétlődik (2 × 2 sorozat), így széles képernyőn sem marad üres hely, és a -50% eltolás varrat nélküli.
  const loop = [...printedPhotos, ...printedPhotos, ...printedPhotos, ...printedPhotos];
  return <section aria-labelledby="printed-title" className="overflow-hidden bg-gradient-to-b from-lavender-soft to-[#EFE4FB] py-14 md:py-20" data-id="element-227" data-mp="9no0fdq5kcbl">
      <div className="px-5" data-id="element-228" data-mp="okgk7j5vsw1">
        <SectionTitle id="printed-title" subtitle="Nyomtasd ki az oldalt, vegyél elő néhány színes ceruzát, és már kezdheted is. Ennyire egyszerű." data-id="element-229" data-mp="pvkc7clx0n5">
          Így néz ki kinyomtatva
        </SectionTitle>
      </div>

      <div className="reviews-marquee-viewport mt-8 pb-4" aria-label="Kinyomtatott oldalak" data-id="element-230" data-mp="2rle16n1vywfl">
        <div className="reviews-marquee-track flex w-max" style={{
        animationDuration: `${printedPhotos.length * 2 * SECONDS_PER_PHOTO}s`,
        animationPlayState: paused ? 'paused' : 'running'
      }} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} onTouchStart={() => setPaused(true)} onTouchEnd={() => setPaused(false)} onTouchCancel={() => setPaused(false)} data-id="element-231" data-mp="2njshoiuujjwf">
          {loop.map((src, i) => <figure key={i} aria-hidden={i >= printedPhotos.length ? true : undefined} className="mr-4 w-[70vw] max-w-[320px] shrink-0 overflow-hidden rounded-3xl bg-white shadow-[0_12px_30px_-18px_rgba(74,58,53,0.4)]" data-id="element-232" data-mp="2ikzdxi5d379g" data-mpi={i}>
              <MediaSlot src={src} slot={`printed-${i % printedPhotos.length + 1}`} alt={`Kinyomtatott, kiszínezett oldal ${i % printedPhotos.length + 1}`} aspect="aspect-[3/4]" data-id="element-233" data-mp="3p0ruk3mg42rj" />
            </figure>)}
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-xl px-5" data-id="element-234" data-mp="9w9lqhdk8lmr">
        <CheckoutCta data-id="element-235" data-mp="9uosqw6w9ar0" />
      </div>
    </section>;
}